
export type Only<T, U> = {
  [P in keyof T]: T[P];
} & {
  // eslint-disable-next-line no-unused-vars
  [P in keyof U]?: never;
};

export type Either<A, B> = (A & Partial<B>) | (B & Partial<A>);


export type NestedKeys<T> = {
  [K in keyof T]: T[K] extends object
    //@ts-expect-error: Funciona
    ? `${string & K}.${NestedKeys<T[K]>}` | `${string & K}`
    : `${string & K}`;
}[keyof T];


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function GetNestedValueArray (path: string[], obj: any): any{
  let result = "";
  path.forEach(p => {
    result += ` ${GetNestedValue(p, obj)}`
  });
  return result;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function GetNestedValue (path: string, obj: any): any{
    const r = path.split('.').reduce((acc, key) => acc?.[key], obj)
  
  return r;
}